import Box from '@material-ui/core/Box';

import Dot from '@/components/dot';
import CheckIcon from '@/components/icons/check';
import type { QuestionProgressDotVariant } from './utils';

interface QuestionProgressDotsProps<T> {
  items?: Array<T | null | undefined> | null;
  getItemId: (item: NonNullable<T>, index: number) => string | number;
  getItemVariant: (item: NonNullable<T>, index: number) => QuestionProgressDotVariant;
  columnGap?: number;
  placeholderCount?: number;
}

const isValidItem = <T,>(item: T | null | undefined): item is NonNullable<T> => !!item;

const QuestionProgressDots = <T,>({
  items,
  getItemId,
  getItemVariant,
  columnGap = 10,
  placeholderCount = 3,
}: QuestionProgressDotsProps<T>) => {
  const preparedItems = (items || []).filter(isValidItem);

  return (
    <Box display="grid" gridTemplateColumns={`repeat(${placeholderCount}, auto)`} gridColumnGap={columnGap}>
      {preparedItems.length
        ? preparedItems.map((item, index) => {
            const variant = getItemVariant(item, index);

            return (
              <Dot key={`dot-${getItemId(item, index)}`} variant={variant} size="large">
                {variant === 'success' ? (
                  <Box
                    component="span"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    style={{ width: '100%', height: '100%' }}
                  >
                    <CheckIcon style={{ width: 12, height: 12, color: '#fff' }} />
                  </Box>
                ) : null}
              </Dot>
            );
          })
        : [...Array(placeholderCount)].map((_, index) => <Dot key={`dot-placeholder-${index}`} size="large" />)}
    </Box>
  );
};

export default QuestionProgressDots;
